export { default } from './pharmaprix-owners-content.component';
